import type { IconSvgProps } from '../Icon.types';

export const TreebulaSimple = ({ width, height }: IconSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25 16"
    fill="none"
  >
    <path
      d="M17.7113 11.4309L23.5099 5.6324L20.2866 2.40914L14.4881 8.19107V0H9.919V8.19107L4.12046 2.39252L0.897196 5.6324L6.69574 11.4309H0V16H7.47663C10.0021 16 12.0457 13.9564 12.0457 11.4309H8.09138V11.1319C10.2845 11.1319 12.0457 9.3541 12.0457 7.17757H12.3448C12.3448 9.37072 14.1225 11.1319 16.2991 11.1319V11.4309H12.3448C12.3448 13.9564 14.3884 16 16.9138 16H24.3904V11.4309H17.7113Z"
      fill="#0F0F0F"
    />
  </svg>
);
